export const imageExampleDuration = 5000
